import { css, cx } from '@eti/styles';
import { isPartner } from '@eti/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const brandLogoStyles = css`
  animation: fadeIn 2s;
  pointer-events: none;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
const brandLogoExceptionsList = {
  supersaver_se: 'supersavertravel',
  flybillet_dk: 'flybillet'
};
const getBrandLogoName = function (brand, siteName) {
  var _brandLogoExceptionsL;
  if (brand === void 0) {
    brand = '';
  }
  return isPartner(brand) ? brand.toLowerCase() : (_brandLogoExceptionsL = brandLogoExceptionsList[siteName]) !== null && _brandLogoExceptionsL !== void 0 ? _brandLogoExceptionsL : brand.toLowerCase();
};
const getBrandClassName = function (brand, shouldUseContrast) {
  if (brand === void 0) {
    brand = '';
  }
  return `${brand.toLowerCase()}${shouldUseContrast ? '--contrast' : ''}`;
};
export const loadLogo = async function (props) {
  if (props === void 0) {
    props = {};
  }
  const {
    className,
    shouldUseContrast,
    brand,
    siteName,
    dataTestId
  } = props;
  const brandLogoName = getBrandLogoName(brand, siteName);
  if (!brandLogoName) {
    console.warn('no brand name specified'); // eslint-disable-line no-console
    return null;
  }
  try {
    const {
      ReactComponent
    } = await import(`@eti/assets/logos/brands/${brandLogoName + (shouldUseContrast ? '--contrast' : '')}.svg`);
    return /*#__PURE__*/_jsx(ReactComponent, {
      className: cx(brandLogoStyles, 'etiBrandLogo', getBrandClassName(brandLogoName, shouldUseContrast), className),
      "data-testid": dataTestId
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`The \`BrandLogo\` for \`${brand}\` failed to load.`);
  }
  return null;
};
//# sourceMappingURL=Utils.js.map